<template>
	<div @click="clickListener" class="switch">
		<p v-if="label">{{ label }}</p>
		<label class="switch-container">
			<input ref="input" type="checkbox" :checked="isChecked">
			<div class="switch-slider" :class="fixedColorClass"></div>
			<div class="row centered">
				<div class="col-6 centered" v-html="getIcon(leftIcon)"></div>
				<div class="col-6 centered" v-html="getIcon(rightIcon)"></div>
			</div>
		</label>
	</div>
</template>

<script>
import {useSvgStore} from "@/shared/stores";

export default {
	setup() {
		const svgStore = useSvgStore();
		return {
			getIcon: svgStore.get,
		}
	},
	name: "AppSwitch",
	emits: ["switched"],
	data() {
		return {
			// false and the switch is on the left, true and the switch is on the right
			isChecked: this.checked,
		}
	},
	props: {
		label: {type: String, default: null},
		checked: {type: Boolean, default: false},
		fixedColor: {type: Boolean, default: false},
		leftIcon: {type: String, default: "iconX"},
		rightIcon: {type: String, default: "iconV"},
		disabled: {type: Boolean, default: false},
	},
	methods: {
		clickListener() {
			if(this.disabled) {
				this.$emit('switched', this.isChecked);
			} else {
				this.isChecked = !this.isChecked;
				this.$emit('switched', this.isChecked);
			}
		},
	},
	computed: {
		fixedColorClass() {
			return this.fixedColor ? 'fixed-color' : '';
		},
	},
	watch: {
		checked(newValue) {
			this.isChecked = newValue;
		}
	}
}
</script>

<style lang="scss" scoped>
.switch {
	@include centered;
	@include columnFlex;
	@include noSelect;
	cursor: pointer;
	align-items: flex-start;

	p {
		margin-bottom: 5px;
		padding: 0 1px;
		text-align: left;
		color: $txt_1;
		font-size: 10px;
		line-height: 15px;
		max-width: 200px;
		width: 100%;
	}

	& * {
		@include noSelect();
		pointer-events: none;
	}
}

.switch-container {
	position: relative;
	display: inline-block;
	width: 92px;
	height: 35px;
	cursor: pointer;

	& * {
		@include noSelect;
	}

	.row {
		height: 100%;
		position: absolute;
		top: 0;

		.col-6 {
			height: 100%;

			&:nth-of-type(1) {
				padding-left: 4px;
			}

			&:nth-of-type(2) {
				padding-right: 4px;
			}

			&:deep(svg) {
				height: calc(100% - 20px);

				.fill {
					fill: var(--color-bg);
				}

				.stroke {
					stroke: var(--color-bg);
				}
			}

			&:nth-of-type(2):deep(svg) {
				.fill {
					fill: var(--color-bg-primary-4);
				}

				.stroke {
					stroke: var(--color-bg-primary-4);
				}
			}

			&:deep(svg path), &:deep(svg circle), &:deep(svg rect) {
				transition: fill .3s $transition, stroke .3s $transition;
			}
		}
	}

	input {
		opacity: 0;
		width: 0;
		height: 0;
		pointer-events: none;
	}

	.switch-slider {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: var(--color-bg);
		-webkit-transition: .4s;
		transition: .4s;
		box-shadow: 0 1px 2px var(--color-box-shadow-3);
		border-radius: 13px;

		&:before, &:after {
			position: absolute;
			content: "";
			height: 29px;
			width: 43px;
			left: 4px;
			top: 50%;
			transform: translateY(-50%);
			-webkit-transition: left .3s $transition, opacity .3s $transition;
			transition: left .3s $transition, opacity .3s $transition;
			border-radius: 11px;
			box-shadow: inset 0 2px 3px var(--color-box-shadow-dark-2);
		}

		&:before {
			background: linear-gradient(to right, var(--color-gradient-disable-left), var(--color-gradient-disable-right));
		}

		&:after {
			background: linear-gradient(to right, var(--color-primary), var(--color-secondary));
		}
	}

	input:checked + .switch-slider:before,
	input:checked + .switch-slider:after {
		left: calc(100% - 47px);
	}

	input:not(:checked) + .switch-slider:not(.fixed-color):after {
		opacity: 0;
	}

	input:checked ~ .row .col-6 {
		&:nth-of-type(1):deep(svg) {
			.fill {
				fill: var(--color-bg-primary-4);
			}

			.stroke {
				stroke: var(--color-bg-primary-4);
			}
		}

		&:nth-of-type(2):deep(svg) {
			.fill {
				fill: var(--color-bg);
			}

			.stroke {
				stroke: var(--color-bg);
			}
		}
	}

	@media (max-width: 768px) {
		width: 68px;
		height: 30px;

		.switch-slider {
			&:before, &:after {
				height: 24px;
				width: 33px;
				left: 3px;
			}
		}

		input:checked + .switch-slider:before,
		input:checked + .switch-slider:after {
			left: calc(100% - 36px);
		}
	}

}

</style>